import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { AppService, I18nService, SetColorsService, UserAgreementType } from 'core'

@Component({
  selector: 'bmprod-user-agreement-page',
  templateUrl: './bmprod-user-agreement-page.component.html',
  styleUrls: ['./bmprod-user-agreement-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodUserAgreementPageComponent implements OnInit {
  isEng: boolean
  colorSettingsMode = false

  data: UserAgreementType

  constructor(
    private appService: AppService,
    private setColorsService: SetColorsService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.isEng = this.i18nService.isEng()
    this.getBeatmakerData()
    this.getColorSettingsMode()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.data = {
          beatmakerName: res.beatmakerName,
          adminEmail: res.ownerData.adminEmail,
          fullName: res.ownerData.fullName,
          host: res.host
        }
      }
    })
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
